import LibSelector from './src/main';

/* istanbul ignore next */
LibSelector.install = function(Vue) {
  Vue.component(LibSelector.name, LibSelector);
};

export default LibSelector;
